import { adkitApi } from "../adkitApi";
import {
  ClubhouseAdKitSamplesDtoSchema,
  type ClubhouseAdKitSamplesDto,
} from "entities/responses/adkit";

const urls = {
  metadata(): string {
    return "/api/ad-kit/metadata";
  },
};

const metadataEndpoints = adkitApi.injectEndpoints({
  endpoints: (build) => ({
    getAdKitMetadata: build.query<ClubhouseAdKitSamplesDto, void>({
      query: () => urls.metadata(),
      transformResponse: (raw: unknown) =>
        ClubhouseAdKitSamplesDtoSchema.parse(raw),
      providesTags: ["Metadata"],
    }),
  }),
});

export const { useGetAdKitMetadataQuery } = metadataEndpoints;
